/**
 * SSO Configuration
 * Centralized configuration for Single Sign-On functionality
 */

export default {
  'clients': [
    {
      'id': 'sitio_web',
      'name': 'Sitio Web Carné Joven Aragón',
      'logo': require('@/assets/images/logo-carne-joven-aragon.svg'),
      'url': process.env.VUE_APP_SSO_SITIO_WEB_URL || '',
      'show_in_profile': true
    },
    {
      'id': 'tienda_online',
      'name': 'Tienda Carné Joven',
      'logo': require('@/assets/images/logo-tienda-online.png'),
      'url': process.env.VUE_APP_SSO_TIENDA_ONLINE_URL || '',
      'show_in_profile': false
    },
  ],
}; 